var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 980,
    height: 902.7,
    viewBox: "0 0 980 902.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_171dc288e0c4123c3331eefd1c94f8a5",
    "data-name": "171dc288e0c4123c3331eefd1c94f8a5",
    transform: "translate(-10 -48.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M416.6,660c220.8,0,392-126.1,389.4-313.3,0-165.7-175.2-298-396.1-298C189.1,48.7,10,181,10,346.7c0,103.2,50.6,213.2,156.3,267.2,0,.7-.2,1.1-.2,1.8,0,44.8-37.3,106.4-52.1,131.7h.1a21.834,21.834,0,0,0-1.9,8.9A22.683,22.683,0,0,0,134.9,779c1.9,0,4.8-.4,5.9-.4.3,0,.4,0,.4.1C219.3,765.9,334.6,678,351.7,657.2a271.519,271.519,0,0,0,44.1,3.1c6.3-.1,13-.3,20.8-.3Zm-90-65.8-39.2,32.6c-9.1,10.4-48.6,43.4-82.6,64.8,20.7-59,19.7-77.7,19.7-77.7l2.9-37.4-33.3-17C109.3,516,71.2,425.8,71.2,346.7c0-131.6,152-236.9,338.7-236.9S744.8,215,744.8,346.7c-.5,146-139.5,253.1-326.2,253.1a357.451,357.451,0,0,1-57.8-3.2l-34.2-2.4ZM990,594c0-83-32.4-146.2-113.3-193.7-2,22-8.6,50.7-15.1,66.6-122.8,299.6-500,255.5-502.2,257.5,60.8,74.2,160.2,121.1,284.9,121.1,6.8,0,12.5.1,17.9.1a240.859,240.859,0,0,0,38.2-2.5c14.8,18,97.8,97,165.3,108.1,0-.1.1-.1.3-.1.9,0,3.5.3,5.2.3a19.568,19.568,0,0,0,19.6-19.6,21.592,21.592,0,0,0-1.6-7.7h.1c-12.7-21.9-32.7-85.9-32.7-124.6,0-.6-.2-1-.2-1.5C947.7,751.2,990,683.1,990,594Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M181.3,361.1a65.895,65.895,0,1,0,19.3-46.5,66.555,66.555,0,0,0-19.3,46.5Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M533.9,361.1a65.895,65.895,0,1,0,19.3-46.5,66.555,66.555,0,0,0-19.3,46.5Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M358.1,361.1a65.895,65.895,0,1,0,19.3-46.5,65.775,65.775,0,0,0-19.3,46.5Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M177.1,361.1a65.895,65.895,0,1,0,19.3-46.5,66.555,66.555,0,0,0-19.3,46.5Z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWhite);
export default __webpack_public_path__ + "static/media/chat-white.7342b15d8ed9910f9cd6ea9cc445a6c4.svg";
export { ForwardRef as ReactComponent };